// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
import AwBreak from 'viewmodel/AwBreakViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import { EnableWhen } from 'js/hocCollection';
const AwButtonEnableWhen = EnableWhen(AwButton);
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
registerDynImportEntry('js/rfqHelper', () => import('js/rfqHelper'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "actions": {
    "getRfqs": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getRfqs( $getRfqsInput: ListRfqsInput) { getRfqs( getRfqsInput: $getRfqsInput) { items totalCount error}}",
            "variables": {
              "getRfqsInput": {
                "collaborationspaceId": "{{props.collaborationspaceid}}",
                "skip": "{{data.rfqsSkip}}",
                "statusFilters": "{{data.statusFilters}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "dataParsers": [{
        "id": "rfqParser",
        "responseObjs": "data.data.getRfqs.items"
      }],
      "outputData": {
        "filterResults": "data.data.getRfqs.items",
        "totalFound": "data.data.getRfqs.totalCount",
        "error": "data.data.getRfqs.error"
      },
      "actionMessages": {},
      "events": {
        "success": [{
          "condition": "error === null || error === undefined",
          "name": "list-rfqs-as-list.success"
        }, {
          "condition": "error === 'EMPTY_COLLAB_SPACE'",
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 400 || errorCode === 400",
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{error}}",
            "errorCode": 400
          }
        }, {
          "condition": "error.statusCode === 403 || errorCode === 403",
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "error.statusCode >= 500 && error.statusCode <= 599",
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "list-rfqs-as-list.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "refreshRfqTable": {
      "actionType": "dataProvider",
      "method": "exampleDataProvider"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    },
    "copyContentToRfq": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation copyContentToRfq( $collaborationspaceId: String, $projectId: String, $contentIds: String, $rfqIds: String) { copyContentToRfq( collaborationspaceId: $collaborationspaceId, projectId: $projectId, contentIds: $contentIds, rfqIds: $rfqIds) }",
            "variables": {
              "collaborationspaceId": "{{props.collaborationspaceid}}",
              "projectId": "{{props.projectid}}",
              "contentIds": "{{props.contentid}}",
              "rfqIds": "{{data.selectedRfqIds}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "copyContentProjectToRfq": "data.data.copyContentToRfq"
      },
      "events": {
        "success": [{
          "condition": "copyContentProjectToRfq.error === null || copyContentProjectToRfq.error === undefined",
          "name": "copy-content-project-to-rfq.success",
          "eventData": {}
        }, {
          "condition": "copyContentProjectToRfq.error === 'EMPTY_COLLAB_SPACE'",
          "name": "copy-content-project-to-rfq.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "copyContentProjectToRfq.error.statusCode === 400 || errorCode === 400",
          "name": "copy-content-project-to-rfq.error",
          "eventData": {
            "error": "{{copyContentProjectToRfq.error}}",
            "errorCode": 400
          }
        }, {
          "condition": "copyContentProjectToRfq.error.statusCode === 403 || errorCode === 403",
          "name": "copy-content-project-to-rfq.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "copyContentProjectToRfq.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "copy-content-project-to-rfq.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "copyContentProjectToRfq.error.statusCode >= 500 && copyContentProjectToRfq.error.statusCode <= 599",
          "name": "copy-content-project-to-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "copy-content-project-to-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "rfqSelectionAction": {
      "actionType": "JSFunction",
      "method": "isRfqSelected",
      "inputData": {
        "data": "{{parameters.eventData}}"
      },
      "outputData": {
        "rfqsSelected": "rfqsSelected",
        "selectedRfqIds": "selectedRfqIds"
      },
      "deps": "js/rfqHelper"
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "projectid": {
      "type": "string"
    },
    "contentid": {
      "type": "string"
    }
  },
  "data": {
    "pageSize": 3,
    "rfqsSkip": 0,
    "statusFilters": ["New Request", "Out for Quote", "Quote received"]
  },
  "onEvent": [{
    "eventId": "list-rfqs-as-list.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-list-rfqs-as-list.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }, {
    "eventId": "exampleDataProvider.selectionChangeEvent",
    "action": "rfqSelectionAction",
    "inputArgs": {
      "eventData": "{{eventData.selectedObjects}}"
    }
  }, {
    "eventId": "copy-content-project-to-rfq.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-copy-content-project-to-rfq.success"
    }
  }, {
    "eventId": "copy-content-project-to-rfq.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-copy-content-project-to-rfq.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "dataProviders": {
    "exampleDataProvider": {
      "action": "getRfqs",
      "response": "{{data.filterResults}}",
      "totalFound": "{{data.totalFound}}",
      "contextMenuCommandsAnchor": "aw_splmTableContextMenu",
      "commandsAnchor": "aw_splmTableCommandsAnchor",
      "selectionModelMode": "multiple",
      "inputData": {
        "selectionModel": "{{subPanelContext.selectionModel}}"
      }
    }
  },
  "columnProviders": {
    "exampleColumnProvider": {
      "frozenColumnIndex": 0,
      "columns": [{
        "name": "icon",
        "displayName": "",
        "maxWidth": 30,
        "minWidth": 30,
        "width": 30,
        "enableColumnMenu": false,
        "pinnedLeft": true
      }, {
        "name": "name",
        "displayName": "{{i18n.quoteName}}",
        "maxWidth": 150,
        "width": 150,
        "enableColumnMenu": false,
        "pinnedLeft": true,
        "isTableCommand": true
      }, {
        "name": "description",
        "displayName": "{{i18n.description}}",
        "minWidth": 150,
        "width": 150,
        "enableColumnMenu": false
      }, {
        "name": "status",
        "displayName": "{{i18n.status}}",
        "maxWidth": 300,
        "minWidth": 80,
        "width": 100,
        "enableColumnMenu": false
      }, {
        "name": "dueDate",
        "displayName": "{{i18n.dueDate}}",
        "minWidth": 80,
        "width": 80,
        "enableColumnMenu": false
      }, {
        "name": "rfqId",
        "displayName": "{{i18n.rfqId}}",
        "minWidth": 0,
        "width": 0,
        "enableColumnMenu": false,
        "enableColumnHiding": true
      }]
    }
  },
  "grids": {
    "listRfqsTable": {
      "dataProvider": "exampleDataProvider",
      "columnProvider": "exampleColumnProvider",
      "addIconColumn": true,
      "gridOptions": {
        "enablePinning": true,
        "enableSorting": true,
        "isFilteringEnabled": true,
        "enableColumnHiding": true
      }
    }
  },
  "functions": {
    "filterRows": {
      "functionName": "filterRows",
      "parameters": ["{{data.dataProviders.exampleDataProvider.startIndex}}", "{{data.pageSize}}"]
    }
  },
  "i18n": {
    "quoteName": ["RfqMessages"],
    "dueDate": ["RfqMessages"],
    "appliedBy": ["RfqMessages"],
    "appliedOn": ["RfqMessages"],
    "name": ["RfqMessages"],
    "status": ["RfqMessages"],
    "creationDate": ["RfqMessages"],
    "description": ["RfqMessages"],
    "owner": ["RfqMessages"],
    "emptyRfqs": ["RfqMessages"],
    "createRfq": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_CREATE_RFQ": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"],
    "rfqId": ["RfqMessages"],
    "Add": ["RfqMessages"]
  },
  "dataParseDefinitions": {
    "rfqParser": {
      "identifier": "{{response.rfqId}}",
      "typeIconURL": "http://localhost:4012/assets/images/cmdQuoteRequestsList16.svg",
      "type": "RFQ",
      "props": {
        "name": {
          "name": "{{i18n.quoteName}}",
          "displayName": "{{i18n.quoteName}}",
          "value": "{{response.name}}",
          "displayValue": "{{response.name}}",
          "type": "String"
        },
        "status": {
          "name": "{{i18n.status}}",
          "displayName": "{{i18n.status}}",
          "value": "{{response.status.name}}",
          "displayValue": "{{response.status.name}}",
          "type": "String"
        },
        "description": {
          "name": "{{i18n.description}}",
          "displayName": "{{i18n.description}}",
          "value": "{{response.description}}",
          "displayValue": "{{response.description}}",
          "type": "String"
        },
        "dueDate": {
          "name": "{{i18n.dueDate}}",
          "displayName": "{{i18n.dueDate}}",
          "value": "{{response.dueDate}}",
          "displayValue": "{{response.dueDate}}",
          "type": "String"
        },
        "rfqId": {
          "name": "{{i18n.rfqId}}",
          "displayName": "{{i18n.rfqId}}",
          "value": "{{response.rfqId}}",
          "displayValue": "{{response.rfqId}}",
          "type": "String",
          "enableColumnHiding": true
        }
      }
    }
  },
  "conditions": {
    "enableCopyContent": {
      "expression": "data.rfqsSelected != null && data.rfqsSelected"
    }
  },
  "_viewModelId": "CopyContentToRfq",
  "_uniqueViewModelId": "CopyContentToRfq",
  "ctx": {
    "rfq": {
      "type": "object"
    }
  }
};

/*
<aw-panel class="aw-layout-full">
    <table>
        <tr class="tableBody">
            <td>
                <aw-splm-table gridid="listRfqsTable"></aw-splm-table>
            <aw-break></aw-break>
            </td>
        </tr>
        <tr class="tableFooter">
            <td>
                <aw-button action="copyContentToRfq" enable-when="conditions.enableCopyContent" size="auto">{{i18n.Add}}</aw-button>
            </td>
        </tr>
    </table>
</aw-panel>


*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal,
    className: "aw-layout-full"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tableBody"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwSplmTable, grids.listRfqsTable), /*#__PURE__*/React.createElement(AwBreak, null))), /*#__PURE__*/React.createElement("tr", {
    className: "tableFooter"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwButtonEnableWhen, {
    action: actions.copyContentToRfq,
    size: "auto",
    enableWhen: AwParseService.instance("conditions.enableCopyContent")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, AwParseService.instance("i18n.Add")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;